  import React, { useEffect, useRef, useState } from "react";
  import { useDispatch } from "react-redux";
  import RangeSliderBorderRadius from "../../../UI/RangeSliderBorderRadius";
  import {
    AlignHorizontalJustifyStart,
    AlignHorizontalJustifyEnd,
    AlignVerticalJustifyStart,
    AlignVerticalJustifyEnd,
    AlignHorizontalSpaceBetween,
    AlignHorizontalSpaceAround,
   
    AlignHorizontalJustifyCenter,
    AlignHorizontalDistributeCenter,
    AlignVerticalJustifyCenter,
    AlignVerticalDistributeCenter,
    AlignVerticalSpaceBetween,
    Hash,
    Frame,
    ChevronDown,
    ChevronUp,
  } from "lucide-react";
  import {
    AlignVerticalSpaceAround,
    AlignVerticalJustifyStretch,
  } from "lucide-react";
import RangeSliderDynamic from "../../../UI/RangeSliderDynamic";
  const ItemMarginUI =  ({ itemsArray, callbackItemValue, objectValue,objectName,displayName ,}) => {
   
  
       const dispatch = useDispatch();  
       const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
              {
                
                dispatch({type: "CURSOR",payload:true  });
            
                dispatch({type: "CURSORTEXT",payload:CursorText})
                dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
                dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
              }
               
              const handleMouseLeave = () => {
                
                dispatch({type: "CURSOR",payload:false})
            
                dispatch({type: "CURSORTEXT",payload:""})
            
                dispatch({type: "CURSORTEXTBG",payload:""})
                dispatch({type: "CURSORTEXTCOLOR",payload:""})
              
            
            }
   const [itemValue, setItemValue] = useState(objectValue);
  
  const [marginVerticalBoth, setMarginVerticalBoth] = useState(false);
  
const [marginTop, setMarginTop] = useState(objectValue?.marginTop);
const [marginBottom, setMarginBottom] = useState(objectValue?.marginBottom);
const [marginLeft, setMarginLeft] = useState(objectValue?.marginLeft);
const [marginRight, setMarginRight] = useState(objectValue?.marginRight);
   return(<>
  <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",position:"relative"}}>
    
  <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"0px",paddingLeft:"5px",display:"flex",justifyContent:"space-between"}}>
                      <div style={{fontSize:"18px",fontWeight:"bold",padding:"0px",marginTop:"-5px",
                 paddingLeft:"10px",display:"flex",justifyContent:"space-between"}}>
              <h4>{displayName} </h4> </div> 
                 <div style={{paddingTop:"0px",position:"relative"}}> <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            
                                             {marginVerticalBoth?<ChevronDown onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                       :<ChevronUp onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>}
                                                                     
                                             </div> 
                              <input type="checkbox" title="Color Theme"   checked={marginVerticalBoth?"yes":""}
                   className="input-textbox"  value={marginVerticalBoth}  name={objectName}  
                   onChange={e=>{setMarginVerticalBoth(e.target.checked);}}/>
                        <span class={"boxCardBorder-two"}></span> </label> </div></div>

       <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"0px",padding:"0px"}}>
  <div  style={{margin:"0px",}}>
                  <div  style={{border:"0px solid rgba(144, 202, 249,1)",}}>
              {marginVerticalBoth?<div className="colorPickerDynamic"  style={{position:"absolute",width:"320px",right:"0px",bottom:"80px",zIndex:"9999999",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)" ,border:"3px solid rgba(144, 202, 249,1)",background:"#ffffff",padding: "8px",paddingTop:"3px", borderRadius:"20px" }}>
                <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"-5px",
                 paddingLeft:"10px",display:"flex",justifyContent:"space-between"}}>
              <h4>{displayName} </h4> </div> 
              {objectValue?.marginTop?.value?<div style={{border:"3px solid rgba(144, 202, 249,1)",background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-between"}}> <div style={{marginTop:"0px"}}> <h4>Top Margin </h4></div> 
         <RangeSliderDynamic   rangeIntervalType="marginTop" rangeStart={1} rangeEnd={200} pxPerType={"px"}  
       setSliderVal={(value)=>{ setMarginTop({value:value,resolution:"px"}) ;callbackItemValue({value:value,resolution:"px"},objectName+"Top")}}  sliderVal={marginTop?.value} />
      
           </div>:""}{objectValue?.marginBottom?.value?<div style={{border:"3px solid rgba(144, 202, 249,1)",background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-between"}}>  <div style={{marginTop:"0px"}}><h4>Bottom Margin</h4></div>
           <RangeSliderDynamic   rangeIntervalType="marginBottom" rangeStart={1} rangeEnd={200} pxPerType={"px"}  
       setSliderVal={(value)=>{ setMarginBottom({value:value,resolution:"px"}) ;callbackItemValue({value:value,resolution:"px"},objectName+"Bottom")}}  sliderVal={marginBottom?.value} />
       </div>:""}{objectValue?.marginLeft?.value?<div style={{border:"3px solid rgba(144, 202, 249,1)",background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-between"}}> <div style={{marginTop:"0px"}}><h4>Left Margin </h4></div>
        <RangeSliderDynamic   rangeIntervalType="marginLeft" rangeStart={1} rangeEnd={200} pxPerType={"px"}  
       setSliderVal={(value)=>{ setMarginLeft({value:value,resolution:"px"}) ;callbackItemValue({value:value,resolution:"px"},objectName+"Left")}}  sliderVal={marginLeft?.value} />
          </div>:""}{objectValue?.marginRight?.value?<div style={{border:"3px solid rgba(144, 202, 249,1)",background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-between"}}>  <div style={{marginTop:"0px"}}><h4>Right Margin</h4></div>
           <RangeSliderDynamic   rangeIntervalType="marginRight" rangeStart={1} rangeEnd={200} pxPerType={"px"}  
       setSliderVal={(value)=>{ setMarginRight({value:value,resolution:"px"}) ;callbackItemValue({value:value,resolution:"px"},objectName+"Right")}}  sliderVal={marginRight?.value} />
       </div>:""}  <div style={{background:"rgb(208, 234, 255)",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-between"}}>
                 <div style={{marginTop:"0px",}}> <h4>Overall Margin </h4></div> 
               <RangeSliderDynamic   rangeIntervalType="layoutMargin" rangeStart={1} rangeEnd={200} pxPerType={"px"}  
       setSliderVal={(value)=>{ setMarginTop({value:value,resolution:"px"}) ;setMarginBottom({value:value,resolution:"px"}) ;setMarginLeft({value:value,resolution:"px"}) ;setMarginRight({value:value,resolution:"px"}) ; callbackItemValue({value:value,resolution:"px"},objectName+"All")}}  sliderVal={marginTop?.value} />
       </div> </div>:"" }  
       
        </div> </div> </div>
          
                        </div>             
                                   </>)
  
      } 
      export default ItemMarginUI;
  
                       
  
